/**
 * The thickness control (docs/06-UI-SPEC.md §6.3.1, SRS C3).
 *
 * The slider sets how thick the line FEELS on screen, so its thumb never moves when
 * the teacher zooms. The number beside it is the canvas-space width that gets stored,
 * and it does change with zoom: 3px at 100%, 1px at 300%, 6px at 50%. That is the
 * approved behaviour — it is not a bug to be corrected.
 */

import { thicknessReadout } from '@opal/shared';

import {
  screenWidthToSlider,
  sliderToScreenWidth,
  SLIDER_MAX,
  SLIDER_MIN,
} from '../../board/thickness.js';
import { useBoardStore } from '../../board/store.js';

export function ThicknessSlider() {
  const targetScreenWidth = useBoardStore((state) => state.targetScreenWidth);
  const zoom = useBoardStore((state) => state.viewport.zoom);
  const setTargetScreenWidth = useBoardStore((state) => state.setTargetScreenWidth);

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Thickness</h3>
      <div className="flex items-center gap-3">
        <input
          type="range"
          min={SLIDER_MIN}
          max={SLIDER_MAX}
          step={1}
          value={screenWidthToSlider(targetScreenWidth)}
          aria-label="Pen thickness"
          onChange={(event) => {
            setTargetScreenWidth(sliderToScreenWidth(Number(event.target.value)));
          }}
          className="h-touch flex-1 accent-primary"
        />
        <span className="tabular w-12 text-right text-base text-text-primary">
          {thicknessReadout(targetScreenWidth, zoom)}
        </span>
      </div>
    </section>
  );
}
